export default ({ axios, mapQueryString }) => ({
    index: (query = {}) => axios.get(`/jobs${mapQueryString(query)}`),
    show: (id = {}) => axios.get(`/jobs/${id}`),
    store: (data) => axios.post(`/jobs`, data),
    update: (id, data) => axios.patch(`/jobs/${id}`, data),
    delete: (id) => axios.delete(`/jobs/${id}`),
})